// extracted by mini-css-extract-plugin
export default {"viewwrapper":"DashboardView_viewwrapper__4JV7t"};